import React from 'react';
import {
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Alert,
} from '@mui/material';
import AuthorsSidebar from '../../components/AuthorsSidebar';
import { CheckCircle, Warning, Gavel, Person } from '@mui/icons-material';

const PublicationEthics: React.FC = () => {
  // Этические нормы, перенесенные из правил публикации
  const ethicalStandards = [
    'Соблюдение авторских прав',
    'Отсутствие плагиата',
    'Раскрытие конфликтов интересов',
    'Этичное проведение исследований',
    'Правильное цитирование источников',
  ];

  const plagiarismTypes = [
    'Прямое копирование текста без указания источника',
    'Парафразирование без указания источника',
    'Самоплагиат - повторное использование собственных работ',
    'Неправильное цитирование или искажение источников',
  ];

  const conflictOfInterests = [
    'Финансовые интересы',
    'Личные отношения',
    'Профессиональные связи',
    'Политические или идеологические предпочтения',
  ];

  return (
    <AuthorsSidebar>
      <Container sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Публикационная этика
      </Typography>
      
      <Typography variant="body1" paragraph>
        Журнал придерживается высоких стандартов публикационной этики и следует рекомендациям 
        международных организаций по научной этике.
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Соблюдение этических норм
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          Все авторы обязаны соблюдать этические принципы научной деятельности
        </Alert>
        <List>
          {ethicalStandards.map((standard, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <CheckCircle color="success" />
              </ListItemIcon>
              <ListItemText primary={standard} />
            </ListItem>
          ))}
        </List>
      </Paper>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Плагиат и самоплагиат
        </Typography>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Журнал использует систему проверки на плагиат «Антиплагиат». Статьи с признаками плагиата будут отклонены.
        </Alert>
        <Typography variant="h6" gutterBottom>
          Требования к оригинальности:
        </Typography>
        <List>
          <ListItem>
            <ListItemText 
              primary="Уникальность текста"
              secondary="Текст должен отличаться от ранее опубликованных материалов автора минимум на 30%"
            />
          </ListItem>
          <ListItem>
            <ListItemText 
              primary="Авторство"
              secondary="Рукописи должны иметь авторство не менее 80%, что подтверждается системой Антиплагиат"
            />
          </ListItem>
        </List>
        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          Виды плагиата:
        </Typography>
        <List>
          {plagiarismTypes.map((type, index) => (
            <ListItem key={index}>
              <ListItemText primary={type} />
            </ListItem>
          ))}
        </List>
      </Paper>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          Конфликт интересов
        </Typography>
        <Typography variant="body1" paragraph>
          Авторы обязаны раскрывать любые потенциальные конфликты интересов, которые могут 
          повлиять на результаты исследования или их интерпретацию.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Типы конфликтов интересов:
        </Typography>
        <List>
          {conflictOfInterests.map((conflict, index) => (
            <ListItem key={index}>
              <ListItemText primary={conflict} />
            </ListItem>
          ))}
        </List>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Авторство и соавторство
        </Typography>
        <Typography variant="body1" paragraph>
          Все лица, внесшие существенный вклад в исследование, должны быть указаны как соавторы. 
          Авторы несут коллективную ответственность за содержание статьи.
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Критерии авторства:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="Существенный вклад в концепцию и дизайн исследования" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Сбор, анализ или интерпретация данных" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Написание статьи или критический пересмотр содержания" />
            </ListItem>
            <ListItem>
              <ListItemText primary="Окончательное одобрение версии для публикации" />
            </ListItem>
          </List>
        </Box>
      </Paper>
      </Container>
    </AuthorsSidebar>
  );
};

export default PublicationEthics;
